import applyChanges from "devextreme/data/apply_changes";

import {
  FETCH_PENDING,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SAVING_PENDING,
  SAVING_SUCCESS,
  SAVING_ERROR,
  SAVING_CANCEL,
  SET_CHANGES,
  SET_EDIT_ROW_KEY,
} from "./dataGridActionUtil";

export interface DataGridState {
  data: any[];
  editRowKey: any;
  changes: any[];
  isLoading: boolean;
}

export function dataGridRreducer(
  state: DataGridState,
  { type, payload }: { type: any; payload?: any },
): DataGridState {
  switch (type) {
    case SAVING_SUCCESS:
      const newData = applyChanges(state.data, [payload.change], { keyExpr: payload.keyExpr });
      return {
        ...state,
        data: newData,
        changes: [],
        editRowKey: null,
        isLoading: false,
      };
    case SAVING_CANCEL:
      return {
        ...state,
        changes: [],
        editRowKey: null,
      };
    case SET_CHANGES:
      return {
        ...state,
        changes: payload,
      };
    case SET_EDIT_ROW_KEY:
      return {
        ...state,
        editRowKey: payload,
      };
    case FETCH_SUCCESS:
      return {
        ...state,
        ...payload,
        isLoading: false,
      };
    case FETCH_PENDING:
    case SAVING_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_ERROR:
    case SAVING_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}

export const DataGridStateInitialState: DataGridState = {
  data: [],
  changes: [],
  editRowKey: null,
  isLoading: false,
};
